import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Sidebar } from "../components";
import { Container } from './Container';
import { setAuthAction } from "../actions";
import { MainController } from '../controllers';
import { Auth } from '../models';
import { MaterialIcon } from '../atoms/lib/MaterialIcon';

class Main extends Container {

	constructor(props) {
		super(props);
		this.state = {
			ie: !!document.documentMode,
			auth: new Auth()
		};
		this.controller = new MainController(this);
	}

	componentDidMount() {
		$('#aboutUs').modal();
		$('#aboutUs').modal("open");
		this.setState({auth: this.props.auth});
		$('#aboutUs').modal();
		$("#aboutUs").modal('open');
	}

	componentWillReceiveProps(nextProps) {
		this.setState({auth: nextProps.auth});
	}

	openModal() {
	  return(
			<div id="aboutUs" className="modal about-us">
				<div className="modal-content">
					<h4>Bem-vindo à ferramenta de Diagnóstico Hídrico da H2O Company</h4>
					<p className="about-text">
						Este questionário está inserido dentro do Módulo de Gestão Hídrica da Plataforma ARCA Sustentabilidade. Trata-se de um completo sistema de gestão de indicadores de sustentabilidade e meio ambiente com módulos para a gestão de ÁGUA e EMISSÕES DE CARBONO.
					</p>
					<p className="about-text">
						O Sistema ARCA permite ao Gestor da Empresa realizar um acompanhamento contínuo do uso da água, emissões de carbono e resíduos sólidos da sua empresa, definindo plano de ação, acompanhando metas e demais indicadores diante de uma linguagem simples e visual. No módulo ÁGUA, este sistema auxilia a sua empresa na melhoria da gestão deste recurso, incluindo identificação de risco hídrico com acompanhamento da situação da bacia hidrográfica local. Além da melhoria na gestão, também auxiliará na geração de dados para outras importantes iniciativas como o GRI, CDP Water e Relatórios de Sustentabilidade.
					</p>
					<h4 className="about-us-subtitle">Sobre este questionário</h4>
					<p className="about-text">
						Os dados disponibilizados através deste questionário são utilizados para diagnóstico inicial da companhia, visando identificar e propor melhorias na gestão de água.
					</p>
					<p className="about-text">
						As informações fornecidas neste questionário são confidenciais, sendo vedada a publicação de dados dos participantes.
					</p>
					<p className="about-text">
						Após preenchimento do questionário, sua empresa receberá gratuitamente um relatório com o resultado de seu desempenho em cata tópico avaliado, o que contribuirá com estratégias de gestão da água na empresa. É de suma importância que sejam utilizados dados autênticos e precisos, uma vez que isso influencia diretamente no resultado desta análise.
					</p>
					<p className="about-text">
						O questionário pode ser salvo a qualquer momento, possibilitando o preenchimento em várias etapas. Após finalizar e enviar o questionário respondido, o usuário não poderá mais editar suas respostas.
					</p>
					<p className="about-text">
						Saiba mais sobre o sistema ARCA e como melhorar seus indicadores de sustentabilidade em <a href="https://www.arcasustentabilidade.com.br" target="_blank">www.arcasustentabilidade.com.br</a>
					</p>
					<div className="modal-footer">
						<a href="#" className="modal-action modal-close waves-effect waves-green btn-flat">Fechar</a>
					</div>
				</div>
			</div>
		);
	}

	renderIeMessage() {
		if(!this.state.ie) return ;
		return(
			<div className={"ie-message"}>
				<div className="header-ie flex -sb">
					<span></span>
					<h4>Atenção</h4>
					<MaterialIcon pointer className="close-modal" size="gnome" type="close" clickAction={() => this.setState({ie: false})}/>
				</div>
				<p className="about-text-ie">
					Você está utilizando o navegador Internet Explorer. Para sua melhor experiência em nosso site,
						pedimos que utilize o navegador Google Chrome ou Mozilla Firefox.
					</p>
				<p className="about-text-ie">
					<a href="https://www.google.com.br/chrome/browser/desktop/index.html" target="_blank">
						Clique aqui para pagina de download do navegador Google Chrome
						</a>
				</p>
			</div>
		);
	}
	

	render() {
		const actions = {
			person: this.controller.logout,
			lock: this.controller.navigateToPassword,
			home: this.controller.navigateToHome,
			work: this.controller.navigateToReport,
			flag: this.controller.showAboutUs,
		};
		return (
			<div className="main">
				{this.renderIeMessage()}
				<div className="flex">
					<Sidebar downloadAction={this.controller.donwloadAction} actions={actions} auth={this.state.auth} changeTabAction={this.controller.linkMenu}/>
					{this.props.children}
					{this.openModal()}
					<a style={{ position: "absolute", visibility: "hidden" }} className="waves-effect waves-light btn modal-trigger" href="#aboutUs"></a>
				</div>
			</div>

		);
	}
}

const map = state => {
	return {
		auth: state.auth.model
	};
};

const actions = {
	setAuthAction,
};

export default connect(map, actions)(Main);


// WEBPACK FOOTER //
// src/containers/Main.js